/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthPlatform
 */
export interface PalAuthPlatform {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    supports_remote_status_sync: boolean;
}

/**
 * Check if a given object implements the PalAuthPlatform interface.
 */
export function instanceOfPalAuthPlatform(value: object): value is PalAuthPlatform {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('supports_remote_status_sync' in value) || value['supports_remote_status_sync'] === undefined) return false;
    return true;
}

export function PalAuthPlatformFromJSON(json: any): PalAuthPlatform {
    return PalAuthPlatformFromJSONTyped(json, false);
}

export function PalAuthPlatformFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthPlatform {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'supports_remote_status_sync': json['supports_remote_status_sync'],
    };
}

export function PalAuthPlatformToJSON(json: any): PalAuthPlatform {
    return PalAuthPlatformToJSONTyped(json, false);
}

export function PalAuthPlatformToJSONTyped(value?: PalAuthPlatform | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'supports_remote_status_sync': value['supports_remote_status_sync'],
    };
}

